import React from "react";
export var UserInfo = function (props) { return (React.createElement("div", { className: "scl-m-userinfo" }, props.children ? props.children : (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "scl-m-userinfo__name" }, props.name + " "),
    (props.role || props.company) && (React.createElement("span", { className: "scl-m-userinfo__info" },
        props.role,
        "\u00A0",
        props.company && (React.createElement("span", { className: "scl-m-userinfo__info", style: { fontSize: "12px", display: "inline-block" } }, props.company)))))))); };
